import { render, staticRenderFns } from "./RecogerFirma3.vue?vue&type=template&id=2ea99417&"
import script from "./RecogerFirma3.vue?vue&type=script&lang=js&"
export * from "./RecogerFirma3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports